import { useLocation } from 'react-use';
import { useEffect } from 'react';

export function usePathnameChange(cb: () => void): void {
  const pathname = useLocation().pathname;

  // eslint-disable-next-line
  useEffect(() => cb(), [pathname]);
}
